<template>
  <v-row
    v-if="settings.layout === 'form' && settings['type-ticket'] && settings['type-ticket'].nome !== 'default-style'"
    :style="$vuetify.breakpoint.mdAndUp ? 'max-width: 1340px; min-width:100%' : 'width: 100vw'"
    no-gutters
    justify="center"
  >
    <v-col
      v-if="formatedText"
      class="mt-10 px-12"
      :cols="$vuetify.breakpoint.mdAndUp ? '5' : '12'"
    >
      <div :style="`text-align: ${settings.text.alignment};`">
        <span v-html="formatedText"></span>
      </div>
    </v-col>

    <v-col
      :class="$vuetify.breakpoint.mdAndUp ? 'pa-12' : 'pa-4'"
      :cols="!$vuetify.breakpoint.mdAndUp ? '12' : '7'"
    >
      <v-card
        :color="settings['layer-color']"
        :class="$vuetify.breakpoint.mdAndUp ? 'pa-10 rounded-xl' : 'pa-7 rounded-xl'"
        elevation="0"
      >
        <v-form ref="form" v-model="valid">
          <form-tickets
            v-for="(form, i) in settings['type-ticket'].extradata"
            :key="i"
            :option="form"
            :section="settings"
          />
        </v-form>

        <v-row
          class="mb-n3 mt-3"
          no-gutters
          justify="center"
          align="center"
        >
          <v-btn
            class="submit-registration"
            :disabled="!valid"
            @click="saveTicket"
            :style="
              `
              background-color: ${MIXIN_getStyle(settings, 'button', 'background-color')} !important;
              border-radius: ${MIXIN_getStyle(settings, 'button', 'border-radius')} !important
              `
            "
            elevation="0"
            :loading="loading"
            rounded
            >
            <b
              :style="
                `
                color: ${MIXIN_getStyle(settings, 'button', 'color')} !important;
                `
              "
            >
              Inscrever-se
            </b>
          </v-btn>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import { GetLayoutSectionMixin } from '../../../mixins/GetLayoutSection'
import FormTickets from '../formTickets/FormTickets.vue'

export default {
  mixins: [GetLayoutSectionMixin],
  props: {
    settings: {type: Object},
    splitArray: {type: Array},
    openCheckout: {type: Function},
  },
  components: {
    FormTickets
  },

  computed: {
    ...mapGetters(["products", "oneCheckoutOpen", "infos", "tickets", "productErrorMessage"]),

    formatedText() {
      if (this.settings.text.content) {
        let content = this.settings.text.content 
        if (!content.includes('<p>') && !content.includes('</p>')) content = `<p>${content}</p>`
        const formated = content
          .replaceAll(
            '<p>',
            `<span style="
              display: block;
              font-family: ${this.MIXIN_getStyle(this.settings, 'text', 'font')} !important; 
              font-size: ${this.MIXIN_getStyle(this.settings, 'text', 'font-size')} !important; 
              color: ${this.MIXIN_getStyle(this.settings, 'text', 'color')} !important; 
              line-height: ${this.MIXIN_getStyle(this.settings, 'text', 'font-size')} !important; 
              font-weight: ${this.MIXIN_getStyle(this.settings, 'text', 'weight')} !important;
              font-style: ${this.MIXIN_getStyle(this.settings, 'text', 'font-style')} !important;
            ">`
          )
          .replaceAll('</p>', "</span>")
        return formated
      } else return ""
    }    
  },

  data: () => ({
    valid: false,
    loading: false,
    eventOnline: null,
  }),

  methods: {
    async saveTicket() {
      // TODO: ARQUIVO E IMAGENS TEM Q FAZER AINDA
      this.loading = true;
      let name, email = "";
      let extradata = [];
      this.settings["type-ticket"].extradata.forEach((data) => {
        if (data.tipo === "nome") name = data.valor;
        if (data.tipo === "email") email = data.valor;
        if (data.tipo !== "upload_imagem" && data.tipo !== "upload_arquivo")
          extradata.push({ codigo: data.codigo, valor: data.valor });
        if (data.tipo === "upload_imagem") {
          extradata.push({ codigo: data.codigo, valor: data.image });
        }
        if (data.tipo === "upload_arquivo") {
          extradata.push({ codigo: data.codigo, valor: data.file });
        }
      });
      const ht = localStorage.getItem("ht")

      await this.$store
        .dispatch("saveTicket", {
          codigo_evento: this.infos["event-id"],
          codigo_produto: this.settings["type-ticket"].codigo_produto,
          codigo_tipo: this.settings["type-ticket"].codigo_tipo,
          nome_cliente: name,
          email_cliente: email,
          extradata: extradata,
          codigo: this.tickets.codigo,
          valor: this.settings["type-ticket"].valor,
          hash_terminal: ht,
        })
        .then((r) => {
          if (r.status === 200) {
            this.eventOnline = r.data;
            this.resetForm();
            if (this.infos.integrations["facebook-pixel"]) {
              var mf = document.createElement("img");
              mf.src = `https://www.facebook.com/tr?id=${this.infos.integrations["facebook-pixel"]}&ev=Purchase&cd[currency]=BRL&cd[value]=0`;
              mf.style = "display:none;";
              mf.height = 1;
              mf.width = 1;
              document.getElementsByTagName("head")[0].appendChild(mf);
            }
          } else this.eventOnline = null;
        })
        .catch((e) => {
          this.loading = false
          let message = 'Ocorreu um erro. Por favor notifique o suporte'
          if (e.response && e.response.data) message = e.response.data.message || message

          this.$store.commit("SET_SNACKBAR", {open: true, message, color: "red" })         
        })

      this.loading = false
      if (this.eventOnline && this.eventOnline.evento_liberado) window.location.href = this.eventOnline.url_acesso_evento
    },

    resetForm() {
      this.$refs.form.reset();
    }        
  }
}
</script>
